import { StringUtils } from '@/common/utils/StringUtils';

export const InstantCellRenderer = ({ value }) => {
  if (!value) return <span/>;
  return <span>{StringUtils.toLocalInstant(value)}</span>;
}